import React, {useEffect, useState} from 'react';
import './header.css';

const Header: React.FC = () => {
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const shouldBeSticky = window.scrollY > 50;
            setIsSticky(shouldBeSticky);
            
            const header = document.querySelector('.header-wrapper');
            if (header) {
                header.classList.toggle('sticky', shouldBeSticky);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="header-wrapper">
            <div className='header-link-bar'>
                <img src="/assets/static/hatchdamh_small.png" alt="Hatch Institute logo"/>
                <span>{isSticky ? 'Hatch DAMH' : 'Hatch Data and Mental Health'}</span>
                <a href="/">Home</a>
                <a href="/#/learn">Learn</a>
								{ /* <a href="/#/login">Portal</a> */ }
            </div>
        </div>
    )
}

export default Header;
